import React, { FC } from 'react';

import { Prices, PurchaseUnit } from '@domains/product';

import { KopecksIso } from '@utils/isomorph';

import { CurrencyPresenter } from '@components/common/CurrencyPresenter/CurrencyPresenter';

type ClassKey = 'root' | 'price' | 'promotionPrice' | 'measureUnits';

type ProductPricePresenterProps = {
    purchaseUnit: PurchaseUnit;
    quantity?: number;
    classes: Classes<ClassKey>;
    measureUnitName?: string;
};
export const ProductPricePresenter: FC<ProductPricePresenterProps> = (props) => {
    const {
        purchaseUnit: { price_in_kopecks: prices, measure_units: measureUnits },
        measureUnitName,
        quantity,
        classes,
    } = props;

    const isInCart = quantity !== undefined;
    let currentPrice: Prices['new'] = prices.new;
    let oldPrice: Prices['old'] = prices.old;

    if (isInCart) {
        currentPrice = KopecksIso.from(KopecksIso.get(prices.new) * quantity);
        oldPrice =
            oldPrice !== null ? KopecksIso.from(KopecksIso.get(oldPrice) * quantity) : oldPrice;
    }

    return (
        <div className={classes.root}>
            <span className={classes.price}>
                <CurrencyPresenter amount={currentPrice} digits={0} />
            </span>
            {oldPrice !== null && (
                <span className={classes.promotionPrice}>
                    <CurrencyPresenter amount={oldPrice} digits={0} />
                </span>
            )}
            {measureUnitName && (
                <span className={classes.measureUnits}>
                    /&nbsp;{measureUnits}&nbsp;{measureUnitName}
                </span>
            )}
        </div>
    );
};
